export default __webpack_public_path__ + "static/media/5_zvuk.4c48583b.wav";